import { connect } from 'react-redux';
import MembershipFormsPage from 'pages/MembershipFormsPageNew';
import newOlsActions from 'store/newOls/actions';
import membershipFormsActions from 'store/membershipForms/actions';
import ErrorActions from 'store/error/actions';

const mapStateToProps = state => {
  return {
    freezeDropdownDetails: state.membershipForms.freezeDropdownDetails,
    cancelDropdownDetails: state.membershipForms.cancelDropdownDetails,
    isCancelIframeLoading: state.membershipForms.isCancelUrlLoading,
    cancelIframeDetails: state.membershipForms.cancelIframeDetails,
    isFreezeIframeLoading: state.membershipForms.isFreezeUrlLoading,
    freezeIframeDetails: state.membershipForms.freezeIframeDetails,
    formsDetails: state.membershipForms.formsDetails,
    isFormsDetailsLoading: state.membershipForms.isFormsDetailsLoading,
  };
};
const mapDispatchToProps = {
  loadFreezeDropdownData: membershipFormsActions.Creators.loadFreezeDropdownDataRequest,
  loadCancelDropdownData: membershipFormsActions.Creators.loadCancelDropdownDataRequest,
  loadCancelIframe: membershipFormsActions.Creators.loadCancelIframeUrlRequest,
  loadFreezeIframe: membershipFormsActions.Creators.loadFreezeIframeUrlRequest,
  loadFormsDetails: membershipFormsActions.Creators.loadFormsDetailsRequest,
  resetIframeDetails: membershipFormsActions.Creators.resetIframeDetails,
  setError: ErrorActions.Creators.setError,
};
export default connect(mapStateToProps, mapDispatchToProps)(MembershipFormsPage);
